import type { ILanugageData } from "src/store/types";

const languageData: Record<string,ILanugageData[]> = {
  //英语
  '1': [
    {
      title: 'English',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: 'Spanish',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: 'Portuguese',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: 'Russian',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: 'French',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: 'German',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: ' Simplified Chinese',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: 'Traditional Chinese',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: 'Japanese',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: 'Indonesian',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: 'Italian', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Thai', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Vietnamese', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Turkish', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Polish', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Dutch', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //西语
  '2': [
    {
      title: 'Inglés',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: 'Español',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: 'Portugués',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: 'Ruso',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: 'Francés',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: 'Alemán',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: 'Chino simplificado',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: 'Chino tradicional',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: 'Japonés',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: 'Indonesio',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: 'Italiano', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Tailandés', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Vietnamita', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Turco', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Polaco', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Holandés', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //葡语
  '3': [
    {
      title: 'Inglês',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: 'Espanhol',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: 'Português',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: 'Russo',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: 'Francês',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: 'Alemão',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: 'Chinês simplificado',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: 'Chinês tradicional',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: 'Japonês',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: 'Indonésio',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: 'Italiano', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Tailandês', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Vietnamita', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Turco', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Polonês', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Holandês', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //俄语
  '4': [
    {
      title: 'Английский',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: 'Испанский',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: 'Португальский',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: 'Русский',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: 'Французский',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: 'Немецкий',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: 'Упрощенный китайский',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: 'Традиционный китайский',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: 'Японский',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: 'Индонезийский',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: 'Итальянский', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Тайский', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Вьетнамский', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Турецкий', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Польский', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Голландский', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //法语
  '5': [
    {
      title: 'Anglais',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: 'Espagnol',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: 'Portugais',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: 'Russe',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: 'Français',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: 'Allemand',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: 'Chinois simplifié',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: 'Chinois traditionnel',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: 'Japonais',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: 'Indonésien',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: 'Italien', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Thaï', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Vietnamien', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Turc', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Polonais', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Néerlandais', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //德语
  '6': [
    {
      title: 'Englisch',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: 'Spanisch',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: 'Portugiesisch',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: 'Russisch',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: 'Französisch',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: 'Deutsch',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: 'Vereinfachtes Chinesisch',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: 'Traditionelles Chinesisch',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: 'Japanisch',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: 'Indonesisch',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: 'Italienisch', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Thailändisch', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Vietnamesisch', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Türkisch', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Polnisch', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Niederländisch', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  '7': [
    {
      title: '英语',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: '西班牙语',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: '葡萄牙语',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: '俄语',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: '法语 ',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: '德语',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: '简体中文',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: '繁体中文',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: '日语',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: '印尼语',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: '意大利语', name: 'Italiano', url: '/it/', key: '11' },
    { title: '泰语', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: '越南语', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: '土耳其语', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: '波兰语', name: 'Polski', url: '/pl/', key: '15' },
    { title: '荷兰语', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //繁体中文
  '8': [
    {
      title: '英語',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: '西班牙語',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: '葡萄牙語',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: '俄語',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: '法語',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: '德語',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: '簡體中文',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: '繁體中文',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: '日語',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: '印尼語',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: '意大利語', name: 'Italiano', url: '/it/', key: '11' },
    { title: '泰語', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: '越南語', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: '土耳其語', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: '波蘭語', name: 'Polski', url: '/pl/', key: '15' },
    { title: '荷蘭語', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //日语
  '9': [
    {
      title: '英語',
      name: 'English',
      url: '/',
      key: '1',
    },
    {
      title: 'スペイン語',
      name: 'Español',
      url: '/es/',
      key: '2',
    },
    {
      title: 'ポルトガル語',
      name: 'Português',
      url: '/pt/',
      key: '3',
    },
    {
      title: 'ロシア語',
      name: 'Pусский',
      url: '/ru/',
      key: '4',
    },
    {
      title: 'フランス語',
      name: 'Français',
      url: '/fr/',
      key: '5',
    },
    {
      title: 'ドイツ語',
      name: 'Deutsch',
      url: '/de/',
      key: '6',
    },
    {
      title: '簡体中国語',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    {
      title: '繁体中国語',
      name: '正體中文',
      url: '/tw/',
      key: '8',
    },
    {
      title: '日本語',
      name: '日本語',
      url: '/jp/',
      key: '9',
    },
    {
      title: 'インドネシア語',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: 'イタリア語', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'タイ語', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'ベトナム語', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'トルコ語', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'ポーランド語', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'オランダ語', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //印度尼西亚语
  '10': [
    { title: 'Bahasa Inggris', name: 'English', url: '/', key: '1' },
    { title: 'Bahasa Spanyol', name: 'Español', url: '/es/', key: '2' },
    { title: 'Portugis', name: 'Português', url: '/pt/', key: '3' },
    { title: 'Bahasa Rusia', name: 'Русский язык', url: '/ru/', key: '4' },
    { title: 'Perancis', name: 'Français', url: '/fr/', key: '5' },
    { title: 'Jerman', name: 'Deutsch', url: '/de/', key: '6' },
    { title: 'Cina Disederhanakan', name: '简体中文', url: '/cn/', key: '7' },
    { title: 'Cina Tradisional', name: '正體中文', url: '/tw/', key: '8' },
    { title: 'Bahasa Jepang', name: 'Japanese', url: '/jp/', key: '9' },
    {
      title: 'Bahasa Indonesia',
      name: 'Bahasa Indonesia',
      url: '/id/',
      key: '10',
    },
    { title: 'Bahasa Italia', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Bahasa Thailand', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Bahasa Vietnam', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Bahasa Turki', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Bahasa Polandia', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Bahasa Belanda', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //意大利语
  '11': [
    { title: 'Inglese', name: 'English', url: '/', key: '1' },
    { title: 'Spagnolo', name: 'Español', url: '/es/', key: '2' },
    { title: 'Portoghese', name: 'Português', url: '/pt/', key: '3' },
    { title: 'Russo', name: 'Русский язык', url: '/ru/', key: '4' },
    { title: 'Francese', name: 'Français', url: '/fr/', key: '5' },
    { title: 'Tedesco', name: 'Deutsch', url: '/de/', key: '6' },
    { title: 'Cinese semplificato', name: '简体中文', url: '/cn/', key: '7' },
    { title: 'Cinese tradizionale', name: '正體中文', url: '/tw/', key: '8' },
    { title: 'Giapponese', name: 'Japanese', url: '/jp/', key: '9' },
    { title: 'Indonesiano', name: 'Indonesian', url: '/id/', key: '10' },
    { title: 'Italiano', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Tailandese', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Vietnamita', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Turco', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Polacco', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Olandese', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //泰语
  '12': [
    { title: 'อังกฤษ', name: 'English', url: '/', key: '1' },
    { title: 'สเปน', name: 'Español', url: '/es/', key: '2' },
    { title: 'โปรตุเกส', name: 'Português', url: '/pt/', key: '3' },
    { title: 'รัสเซีย', name: 'Русский язык', url: '/ru/', key: '4' },
    { title: 'ฝรั่งเศส', name: 'Français', url: '/fr/', key: '5' },
    { title: 'เยอรมัน', name: 'Deutsch', url: '/de/', key: '6' },
    { title: 'จีนตัวย่อ', name: '简体中文', url: '/cn/', key: '7' },
    { title: 'จีนตัวอักษร', name: '正體中文', url: '/tw/', key: '8' },
    { title: 'ญี่ปุ่น', name: 'Japanese', url: '/jp/', key: '9' },
    { title: 'อินโดนีเซีย', name: 'Indonesian', url: '/id/', key: '10' },
    { title: 'อิตาเลียน', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'ไทย', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'เวียตนาม', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'ตุรกี', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'โปแลนด์', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'เนเธอร์แลนด์', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //越南语
  '13': [
    { title: 'Tiếng Anh', name: 'English', url: '/', key: '1' },
    { title: 'Tiếng Tây Ban Nha', name: 'Español', url: '/es/', key: '2' },
    { title: 'Tiếng Bồ Đào Nha', name: 'Português', url: '/pt/', key: '3' },
    { title: 'Tiếng Nga', name: 'Русский язык', url: '/ru/', key: '4' },
    { title: 'Tiếng Pháp', name: 'Français', url: '/fr/', key: '5' },
    { title: 'Tiếng Đức', name: 'Deutsch', url: '/de/', key: '6' },
    { title: 'Tiếng Trung giản thể', name: '简体中文', url: '/cn/', key: '7' },
    { title: 'Tiếng Trung phồn thể', name: '正體中文', url: '/tw/', key: '8' },
    { title: 'Tiếng Nhật', name: 'Japanese', url: '/jp/', key: '9' },
    { title: 'Tiếng Indonesia', name: 'Indonesian', url: '/id/', key: '10' },
    { title: 'Tiếng Ý', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Tiếng Thái', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Tiếng Việt', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Tiếng Thổ Nhĩ Kỳ', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Tiếng Ba Lan', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Tiếng Hà Lan', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //土耳其
  '14': [
    { title: 'İngilizce', name: 'English', url: '/', key: '1' },
    { title: 'İspanyolca', name: 'Español', url: '/es/', key: '2' },
    { title: 'Portekizce', name: 'Português', url: '/pt/', key: '3' },
    { title: 'Rusça', name: 'Русский язык', url: '/ru/', key: '4' },
    { title: 'Fransızca', name: 'Français', url: '/fr/', key: '5' },
    { title: 'Almanca', name: 'Deutsch', url: '/de/', key: '6' },
    {
      title: 'Basitleştirilmiş Çince',
      name: '简体中文',
      url: '/cn/',
      key: '7',
    },
    { title: 'Geleneksel Çince', name: '正體中文', url: '/tw/', key: '8' },
    { title: 'Japonca', name: 'Japanese', url: '/jp/', key: '9' },
    { title: 'Endonezyaca', name: 'Indonesian', url: '/id/', key: '10' },
    { title: 'İtalyanca', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Tayca', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Vietnamca', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Türkçe', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Lehçe', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Hollandaca', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //波兰语
  '15': [
    { title: 'Angielski', name: 'English', url: '/', key: '1' },
    { title: 'Hiszpański', name: 'Español', url: '/es/', key: '2' },
    { title: 'Portugalski', name: 'Português', url: '/pt/', key: '3' },
    { title: 'Rosyjski', name: 'Русский язык', url: '/ru/', key: '4' },
    { title: 'Francuski', name: 'Français', url: '/fr/', key: '5' },
    { title: 'Niemiecki', name: 'Deutsch', url: '/de/', key: '6' },
    { title: 'Chiński uproszczony', name: '简体中文', url: '/cn/', key: '7' },
    { title: 'Chiński tradycyjny', name: '正體中文', url: '/tw/', key: '8' },
    { title: 'Japoński', name: 'Japanese', url: '/jp/', key: '9' },
    { title: 'Indonezyjski', name: 'Indonesian', url: '/id/', key: '10' },
    { title: 'Włoski', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Tajski', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Wietnamski', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Turecki', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Polski', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Holenderski', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
  //荷兰语
  '16': [
    { title: 'Engels', name: 'English', url: '/', key: '1' },
    { title: 'Spaans', name: 'Español', url: '/es/', key: '2' },
    { title: 'Portugees', name: 'Português', url: '/pt/', key: '3' },
    { title: 'Russisch', name: 'Русский язык', url: '/ru/', key: '4' },
    { title: 'Frans', name: 'Français', url: '/fr/', key: '5' },
    { title: 'Duits', name: 'Deutsch', url: '/de/', key: '6' },
    { title: 'Vereenvoudigd Chinees', name: '简体中文', url: '/cn/', key: '7' },
    { title: 'Traditioneel Chinees', name: '正體中文', url: '/tw/', key: '8' },
    { title: 'Japans', name: 'Japanese', url: '/jp/', key: '9' },
    { title: 'Indonesisch', name: 'Indonesian', url: '/id/', key: '10' },
    { title: 'Italiaans', name: 'Italiano', url: '/it/', key: '11' },
    { title: 'Thais', name: 'ภาษาไทย', url: '/th/', key: '12' },
    { title: 'Vietnamees', name: 'Tiếng Việt', url: '/vi/', key: '13' },
    { title: 'Turks', name: 'Türkçe', url: '/tr/', key: '14' },
    { title: 'Pools', name: 'Polski', url: '/pl/', key: '15' },
    { title: 'Nederlands', name: 'Nederlands', url: '/nl/', key: '16' },
  ],
};

export default languageData;
